import React, { useState, useEffect } from 'react';
import { useFadeInOnScroll } from '../../hooks/useScrollEffects';
import './TestimonialsSection.css';
import './TestimonialsSection2.css';

const TestimonialsSection = () => {
  // Hooks para efeitos de scroll com layers sincronizados
  const { isVisible: titleVisible, elementRef: titleRef, transformStyle: titleTransform } = useFadeInOnScroll('TITLE');
  const { isVisible: cardsVisible, elementRef: cardsRef, transformStyle: cardsTransform } = useFadeInOnScroll('CONTENT');
  const { isVisible: ctaVisible, elementRef: ctaRef, transformStyle: ctaTransform } = useFadeInOnScroll('BUTTON');

  // Estado para o carrossel
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar se é mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Funções do carrossel
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const scrollToHero = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const testimonials = [
    {
      id: 1,
      name: "Vinícius Vaz",
      role: "Aluno SBX",
      content: "Vinícius (25 anos) conheceu o mercado em Abril/2024 e comprova o método AWP de Eduardo. O mentor ensinou-o a focar no quanto se pode perder (gestão de risco), protegendo as operações e garantindo consistência de longo prazo. Partindo do zero, ele alcançou resultados crescentes, fazendo do day trade sua carreira principal.",
      videoUrl: "https://www.youtube.com/embed/fGp_oDuZbrs?controls=0&modestbranding=1&rel=0&showinfo=0&fs=0&cc_load_policy=0&iv_load_policy=3&autohide=1"
    },
    {
      id: 2,
      name: "Victor Mota",
      role: "Aluno SBX",
      content: "Victor Mota (4 anos de mercado) era empresário e enfrentou dificuldades financeiras em 2020. Buscou ajuda de Eduardo, operando há 2 anos de forma consistente e lucrativa. O curso o fez focar no aspecto psicológico (90%) do mercado. Após ser convidado para o hub, seus ganhos cresceram de forma exponencial. Hoje, ele vive 100% de mercado.",
      videoUrl: "https://www.youtube.com/embed/F0I_bx4DAAA?controls=0&modestbranding=1&rel=0&showinfo=0&fs=0&cc_load_policy=0&iv_load_policy=3&autohide=1"
    },
    {
      id: 3,
      name: "Lucca Carmel",
      role: "Aluno SBX",
      content: "Luca Rabelo (1,5 ano de mercado) iniciou sem visão, mas aprendeu com Eduardo sobre correlações econômicas e o método AWP. O ponto crucial foi dominar o controle emocional, superando a raiva no simulador. Ao ver resultados e operar diariamente, o day trade se tornou sua carreira principal.",
      videoUrl: "https://www.youtube.com/embed/1kHLq9ExsbU?controls=0&modestbranding=1&rel=0&showinfo=0&fs=0&cc_load_policy=0&iv_load_policy=3&autohide=1"
    }
  ];

  return (
    <div className="testimonials-section">
      <div className="testimonials-content">
        <h2 
          ref={titleRef}
          className={`section-title scroll-fade-in ${titleVisible ? 'visible' : ''}`}
          style={titleTransform}
        >
          Veja o que os alunos da SBX estão falando
        </h2>
        
        <div 
          ref={cardsRef}
          className={`testimonials2-ticker-container scroll-fade-in ${cardsVisible ? 'visible' : ''} ${isMobile ? 'carousel-mode' : ''}`}
          style={cardsTransform}
        >
          {isMobile ? (
            // Carrossel para mobile
            <div className="testimonials2-carousel">
              <div className="testimonials2-carousel-wrapper">
                <div 
                  className="testimonials2-carousel-track"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {testimonials.map((testimonial, index) => (
                    <div key={testimonial.id} className="carousel-slide">
                      <div className="testimonial2-card">
                        <div className="testimonial2-header">
                          <div className="testimonial2-info">
                            <h4 className="testimonial2-name">{testimonial.name}</h4>
                            <p className="testimonial2-role">{testimonial.role}</p>
                          </div>
                        </div>

                        <div className="testimonial2-video">
                          <iframe
                            src={testimonial.videoUrl}
                            title={`Depoimento ${testimonial.name}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="testimonial-video-iframe"
                          ></iframe>
                        </div>

                        <div className="testimonial2-content">
                          <p className="testimonial2-text">"{testimonial.content}"</p>
                        </div>

                        <div className="testimonial2-rating">
                          <span>⭐⭐⭐⭐⭐</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Controles do carrossel */}
              <button className="carousel-btn carousel-btn-prev" onClick={prevSlide}>
                &#8249;
              </button>
              <button className="carousel-btn carousel-btn-next" onClick={nextSlide}>
                &#8250;
              </button>
              
              {/* Indicadores */}
              <div className="carousel-dots">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  />
                ))}
              </div>
            </div>
          ) : (
            // Ticker para desktop
            <div className="testimonials2-ticker">
              {/* Primeira sequência de testimonials */}
              {testimonials.map((testimonial) => (
                <div key={`first-${testimonial.id}`} className="testimonial2-card">
                  <div className="testimonial2-header">
                    <div className="testimonial2-info">
                      <h4 className="testimonial2-name">{testimonial.name}</h4>
                      <p className="testimonial2-role">{testimonial.role}</p>
                    </div>
                  </div>
                  
                  <div className="testimonial2-video">
                    <iframe
                      src={testimonial.videoUrl}
                      title={`Depoimento ${testimonial.name}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="testimonial-video-iframe"
                    ></iframe>
                  </div>
                  
                  <div className="testimonial2-content">
                    <p className="testimonial2-text">"{testimonial.content}"</p>
                  </div>
                  
                  <div className="testimonial2-rating">
                    <span>⭐⭐⭐⭐⭐</span>
                  </div>
                </div>
              ))}
              
              {/* Segunda sequência de testimonials para continuidade */}
              {testimonials.map((testimonial) => (
                <div key={`second-${testimonial.id}`} className="testimonial2-card">
                  <div className="testimonial2-header">
                    <div className="testimonial2-info">
                      <h4 className="testimonial2-name">{testimonial.name}</h4>
                      <p className="testimonial2-role">{testimonial.role}</p>
                    </div>
                  </div>
                  
                  <div className="testimonial2-video">
                    <iframe
                      src={testimonial.videoUrl}
                      title={`Depoimento ${testimonial.name}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="testimonial-video-iframe"
                    ></iframe>
                  </div>
                  
                  <div className="testimonial2-content">
                    <p className="testimonial2-text">"{testimonial.content}"</p>
                  </div>
                  
                  <div className="testimonial2-rating">
                    <span>⭐⭐⭐⭐⭐</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div className="testimonials-decorative-blur"></div>
        
        <button 
          ref={ctaRef}
          className={`cta-button scroll-fade-in ${ctaVisible ? 'visible' : ''}`} 
          style={ctaTransform}
          onClick={scrollToHero}
        >
          Vagas Limitadas!
        </button>
      </div>
    </div>
  );
};

export default TestimonialsSection;
